import api from './client';

export const fetchProducts = (params: any) =>
  api.get('/products', { params }).then(res => res.data);

export const fetchProductCategories = () =>
  api.get('/products/categories').then(res => res.data);

export const fetchProductTags = () =>
  api.get('/products/tags').then(res => res.data);

export const updateProduct = (productId: number, data: any) =>
  api.put(`/products/${productId}`, data).then(res => res.data);

export const fetchShipStationInventory = (params: any) =>
  api.post('/shipstation-inventory', params).then(res => res.data);

export const fetchShipStationWarehouses = () =>
  api.get('/shipstation-inventory/warehouses').then(res => res.data);

export const fetchShipStationInventoryStats = () =>
  api.get('/shipstation-inventory/stats').then(res => res.data);

export const fetchShipStationLocations = (warehouseId?: string) =>
  api.get('/shipstation-inventory/locations', { params: warehouseId ? { warehouseId } : {} }).then(res => res.data);

export const fetchProductWarehouseLocations = () =>
  api.get('/products/warehouse-locations').then(res => res.data);
